import React, { Component } from 'react'
import Select from 'react-select';
import { translate } from "react-translate"

@translate("SearchAutocomplete")
export default class SearchAutocomplete extends Component {

	constructor (props) {
    super(props)

    this.state = {
      disabled: false,
      cant: 0
    }
    this.countSelected = this.countSelected.bind(this)
  }

 	countSelected(value) {
		this.props.onChangeSelection(value)
		 this.setState({cant: this.state.cant + 1});
 		if (this.state.cant === 3){
			this.setState({disabled: true});
 		}
 		else{
 			this.setState({disabled: false});
 		}
  }

	render(){

		const {
			administrative_areas,
			onChangeSelection,
			administrative_areas_selected,
			all_administrative_areas,
			t,
			loading
		} = this.props;

		let disabled = false;
		var options = [];
		let allAdministrativeAreas = [];

		for (var i in administrative_areas){
			let z = {
				value: administrative_areas[i].id,
				label: administrative_areas[i].name,
				type: t(administrative_areas[i].type),
				priority: administrative_areas[i].priority
			}
			options.push(z)
		}

		for (var i in all_administrative_areas){
			let z = {
				value: all_administrative_areas[i].id,
				label: all_administrative_areas[i].name,
				type: all_administrative_areas[i].type,
				priority: all_administrative_areas[i].priority
			}
			allAdministrativeAreas.push(z)
		}

		if (loading) {
			return <Select
				autosize={true}
				multi={true}
				disabled={true}
				clearable={false}
				value={"cargando..."}
				placeholder={"Cargando..."}
				options={[]}
			/>
		}

		var orden_por = function(field, reverse, primer){
		   var key = primer ?
		       function(x) {return primer(x[field])} :
		       function(x) {return x[field]};

		   reverse = !reverse ? 1 : -1;

		   return function (a, b) {
		       return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
	     }
		}

    let administrative_areas_selected_complete = administrative_areas_selected.map((nsel)=>{
      if (allAdministrativeAreas.length==0) return nsel;
      return allAdministrativeAreas.find((o)=>{
        return nsel.value == o.value
      })
    })
		//options.sort(orden_por('priority', false, function(a){return a.toUpperCase()}));

		return(
			<Select
        className='search-autocomplete-selector searchbar-location-selector'
				autosize={true}
				multi={true}
				disabled={false}
				clearable={false}
				value={administrative_areas_selected_complete}
				// placeholder={t("Busque_zona")}
				placeholder={''}
				options={options}
				optionComponent={Option}
				onChange={this.countSelected}
			/>
		)
	}
}

const Option = ({option, className, children, onSelect, onFocus, isFocused}) => {
	const handleMouseDown = (event) => {
		event.preventDefault();
		event.stopPropagation();
		onSelect(option, event);
	}
	const handleMouseEnter = (event) => {
		onFocus(option, event);
	}
	const handleMouseMove = (event) => {
		if (isFocused) return;
		onFocus(option, event);
	}
	return (
		<div
			className={className}
			onMouseDown={handleMouseDown}
			onMouseEnter={handleMouseEnter}
			onMouseMove={handleMouseMove}>
			{children}
			<p>{option.type}</p>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/SearchAutoComplete/SearchAutocomplete.component.js